import React, { useEffect, useState } from "react";
import BlockUserWigets from "./components/BlockUserWigets";
import { HiSearch } from "react-icons/hi";
import AllUsers from "./components/AllUsers";
import { getAllUser } from "Common Usage/apiService";
import BlockUsers from "./components/BlockUsers";
import ReportUsers from "./components/ReportUsers";
import { usePermission } from "Context/PermissionContext";

const BlockUser = () => {
  const [activeTab, setActiveTab] = useState("All Users");
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalUsers, setTotalUsers] = useState(0);
  const [blockedUsers, setBlockedUsers] = useState(0);

  const { permissions } = usePermission();
  const currentTabPermissions =
    permissions?.users?.subModule?.BlockUser?.permissions;

  const limit = 5;

  useEffect(() => {
    fetchUsers(currentPage, searchTerm, activeTab);
  }, [searchTerm, currentPage, activeTab]);

  const fetchUsers = async (page = 1, search = "", filter = "All Users") => {
    try {
      const data = await getAllUser(page, search, filter, limit);

      setUsers(data?.data || []);
      setTotalPages(data?.totalPages || 1);
      setTotalUsers(data?.counts?.totalUsers || 0);
      setBlockedUsers(data?.counts?.blockedUsers || 0);
    } catch (error) {
      console.log("getAllUser-Error", error.message);
    }
  };

  return (
    <React.Fragment>
      <BlockUserWigets totalUsers={totalUsers} blockedUsers={blockedUsers} />

      {/* Tabs */}
      <div className="my-5 flex flex-col">
        <div className="hidden sm:flex">
          {/* All Users Tab  */}
          <button
            className={`px-16 py-2 ${
              activeTab === "All Users"
                ? "bg-gradient-to-br from-[#f8b7d5] to-white font-semibold"
                : "bg-transparent"
            }`}
            onClick={() => {
              setActiveTab("All Users");
              setCurrentPage(1);
            }}
          >
            All Users
          </button>

          {/* Blocked Users Tab  */}
          <button
            className={`px-16 py-2 ${
              activeTab === "Blocked User"
                ? "bg-gradient-to-bl from-[#f8b7d5] to-white font-semibold"
                : "bg-transparent"
            }`}
            onClick={() => {
              setActiveTab("Blocked User");
              setCurrentPage(1);
            }}
          >
            Blocked User
          </button>

          {/* Report Users Tab  */}
          <button
            className={`px-16 py-2 ${
              activeTab === "Report Users"
                ? "bg-gradient-to-bl from-[#f8b7d5] to-white font-semibold"
                : "bg-transparent"
            }`}
            onClick={() => {
              setActiveTab("Report Users");
              setCurrentPage(1);
            }}
          >
            Report Users
          </button>
        </div>

        {/* Search */}
        {activeTab !== "Report Users" && (
          <div className="flex flex-col items-center justify-between bg-white p-5 shadow-sm md:flex-row">
            <div className="w-full md:w-1/2 md:flex-1">
              <div className="relative">
                <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-500">
                  <HiSearch color="#c51369" className="h-5 w-5" />
                </span>
                <input
                  type="text"
                  placeholder="Search..."
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1);
                  }}
                  className="block w-full rounded-md border px-4 py-2 pl-10 md:w-1/2"
                />
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Tab Content */}
      {activeTab === "All Users" ? (
        <AllUsers
          users={users}
          fetchUsers={fetchUsers}
          currentPage={currentPage}
          totalPages={totalPages}
          setCurrentPage={setCurrentPage}
          currentTabPermissions={currentTabPermissions}
        />
      ) : activeTab === "Blocked User" ? (
        <BlockUsers
          users={users}
          fetchUsers={fetchUsers}
          currentPage={currentPage}
          totalPages={totalPages}
          setCurrentPage={setCurrentPage}
          currentTabPermissions={currentTabPermissions}
        />
      ) : (
        <ReportUsers />
        // <div className="flex flex-col items-center justify-between bg-white p-8 mt-0 shadow-sm md:flex-row"> </div>
      )}
    </React.Fragment>
  );
};

export default BlockUser;
